import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaChevronLeft, FaChevronRight, FaFileInvoiceDollar, FaTimes, FaCheck } from 'react-icons/fa';
import api from '../../services/api';
import ReactSelect from '../ReactSelect';
import { FinField } from '../FinField';
import '../../css/financeiro-parcela-pagar.css';

// Fatura do cartão (treinamento 07/10, item 15): lançamentos do ciclo pelo dia de
// corte do cartão + "Gerar conta da fatura" (cria a conta em Contas a Pagar, já
// liberada; pagar devolve o limite do cartão). API: FaturaCartaoController.

const moeda = (v) => 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const br = (iso) => (iso ? String(iso).slice(0, 10).split('-').reverse().join('/') : '—');
const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

export default function FaturaCartao({ cartao, onGerada }) {
    const token = localStorage.getItem('token');
    const [mesAno, setMesAno] = useState(null); // { ano, mes } — null = fatura em aberto hoje
    const [fatura, setFatura] = useState(null);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');
    const [modal, setModal] = useState(null); // { favorecido: {value,label}|null, salvando }

    const carregar = (alvo) => {
        if (!cartao || !cartao.id) return;
        setCarregando(true);
        setErro('');
        api({ method: 'get', action: '/financeiroCaixa/' + cartao.id + '/fatura', token: token, params: alvo || undefined })
            .then(r => { setFatura(r.data.data); setMesAno({ ano: r.data.data.ano, mes: r.data.data.mes }); })
            .catch(e => { setFatura(null); setErro((e.response && e.response.data && e.response.data.mensagem) || 'Erro ao carregar a fatura.'); })
            .finally(() => setCarregando(false));
    };

    useEffect(() => { setMesAno(null); carregar(null); }, [cartao && cartao.id]); // eslint-disable-line react-hooks/exhaustive-deps

    const navegar = (delta) => {
        if (!mesAno) return;
        const total = mesAno.ano * 12 + (mesAno.mes - 1) + delta;
        carregar({ ano: Math.floor(total / 12), mes: (total % 12) + 1 });
    };

    const gerar = () => {
        if (!modal || !modal.favorecido) return;
        setModal(Object.assign({}, modal, { salvando: true }));
        api({ method: 'post', action: '/financeiroCaixa/' + cartao.id + '/fatura/gerar', token: token,
            data: { ano: fatura.ano, mes: fatura.mes, participante: modal.favorecido.value, empresa: localStorage.getItem('empresa') } })
            .then(r => {
                toast.success((r.data && r.data.mensagem) || 'Conta da fatura gerada.');
                setModal(null);
                setFatura(r.data.data);
                if (onGerada) onGerada();
            })
            .catch(e => {
                toast.error((e.response && e.response.data && e.response.data.mensagem) || 'Erro ao gerar a conta da fatura.');
                setModal(prev => (prev ? Object.assign({}, prev, { salvando: false }) : prev));
            });
    };

    const rotulo = fatura ? MESES[fatura.mes - 1] + ' / ' + fatura.ano : '';

    return (
        <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
            {/* Cabeçalho: navegação entre faturas */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', borderBottom: '1px solid var(--fin-sf1)', flexWrap: 'wrap' }}>
                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => navegar(-1)} disabled={carregando || !mesAno} title="Fatura anterior">
                    <FaChevronLeft size={11} />
                </button>
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--fin-tx)', textTransform: 'capitalize' }}>
                        Fatura {rotulo || '…'}
                    </div>
                    {fatura && (
                        <div className="fin-pp__cell-muted" style={{ fontSize: 12 }}>
                            Compras de {br(fatura.ciclo.inicio)} a {br(fatura.ciclo.fim)} (corte dia {fatura.cartao.dia_corte})
                            {' · '}vence {fatura.ciclo.vencimento ? br(fatura.ciclo.vencimento) : '— (cadastre o dia de vencimento)'}
                        </div>
                    )}
                </div>
                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => navegar(1)} disabled={carregando || !mesAno} title="Próxima fatura">
                    <FaChevronRight size={11} />
                </button>
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
                    {fatura && (
                        <span style={{ fontSize: 15, fontWeight: 700, color: fatura.total > 0 ? 'var(--fin-dg)' : 'var(--fin-tx)' }}>
                            Total {moeda(fatura.total)}
                        </span>
                    )}
                    {fatura && fatura.conta ? (
                        <Link className="fin-pp__btn fin-pp__btn--sm" to={'/financeiroParcelaDetalhe/' + fatura.conta.parcela_id}>
                            {fatura.conta.paga ? <><FaCheck size={11} /> Fatura paga — ver conta</> : 'Ver conta da fatura'}
                        </Link>
                    ) : (
                        <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary"
                            disabled={!fatura || fatura.total <= 0 || carregando}
                            title={fatura && fatura.total <= 0 ? 'Fatura sem valor a pagar' : 'Cria a conta da fatura em Contas a Pagar'}
                            onClick={() => setModal({ favorecido: null, salvando: false })}>
                            <FaFileInvoiceDollar size={12} /> Gerar conta da fatura
                        </button>
                    )}
                </div>
            </div>

            {fatura && fatura.sem_comprovante > 0 && (
                <div className="fin-pp" style={{ padding: '10px 16px 0' }}>
                    <div className="fin-pp__banner is-warn" style={{ marginBottom: 0 }}>
                        {fatura.sem_comprovante} lançamento{fatura.sem_comprovante !== 1 ? 's' : ''} sem comprovante — confira antes de fechar a fatura.
                    </div>
                </div>
            )}

            {erro ? (
                <div className="fin-pp__empty" style={{ padding: 30, color: 'var(--fin-wn)' }}>{erro}</div>
            ) : carregando && !fatura ? (
                <div className="fin-pp__empty" style={{ padding: 30 }}>Carregando fatura…</div>
            ) : fatura && (
                <div className="fin-pp__tblwrap">
                    <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                        <thead>
                            <tr>
                                <th style={{ width: 100 }}>Data</th>
                                <th>Descrição</th>
                                <th>Fornecedor / Evento</th>
                                <th style={{ width: 120 }}>Comprovante</th>
                                <th style={{ textAlign: 'right', width: 140 }}>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fatura.lancamentos.length === 0 ? (
                                <tr><td colSpan={5} className="fin-pp__empty">Nenhum lançamento neste cartão no período da fatura.</td></tr>
                            ) : fatura.lancamentos.map(l => (
                                <tr key={l.id}>
                                    <td className="fin-pp__cell-muted">{br(l.data)}</td>
                                    <td>{l.descricao}</td>
                                    <td>
                                        <div className="fin-pp__cell-strong">{l.fornecedor || '—'}</div>
                                        {l.evento && <div className="fin-pp__cell-muted" style={{ fontSize: 12 }}>{l.evento}</div>}
                                    </td>
                                    <td>
                                        {l.valor <= 0 ? <span className="fin-pp__cell-muted">—</span>
                                            : l.comprovante ? <span className="fin-pp__minitag is-ok">✓ Recebido</span>
                                                : <span className="fin-pp__minitag is-warn">Falta</span>}
                                    </td>
                                    <td style={{ textAlign: 'right', fontWeight: 600, color: l.valor < 0 ? 'var(--fin-ok)' : 'var(--fin-tx)' }}>
                                        {l.valor < 0 ? '− ' + moeda(-l.valor) : moeda(l.valor)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal: gerar conta da fatura (favorecido escolhido na hora — opção 1 do Rafael) */}
            {modal && fatura && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" style={{ zIndex: 1060 }}
                    onClick={(e) => { if (e.target === e.currentTarget && !modal.salvando) setModal(null); }}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: 520 }}>
                        <div className="modal-content fin-pp__modal fin-pp__modal--flow">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaFileInvoiceDollar size={16} /></span>
                                <h3 className="fin-pp__modal-title">Gerar conta da fatura
                                    <span className="fin-pp__modal-sub" style={{ textTransform: 'capitalize' }}>{cartao.nome} · {rotulo}</span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => !modal.salvando && setModal(null)}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body" style={{ minHeight: 260 }}>
                                <p className="fin-pp__cell-muted" style={{ marginTop: 0 }}>
                                    Cria em Contas a Pagar a conta de <strong>{moeda(fatura.total)}</strong>, vencimento <strong>{br(fatura.ciclo.vencimento)}</strong>,
                                    {' '}já liberada para pagamento. Ao pagar, o limite do cartão é devolvido.
                                </p>
                                <div className="fin-pp__filters">
                                    <FinField label="Favorecido (banco emissor do cartão)" required full>
                                        <ReactSelect
                                            defaultOptions={false}
                                            placeholder="Digite o nome do banco"
                                            value={modal.favorecido}
                                            onChange={e => setModal(prev => Object.assign({}, prev, { favorecido: e || null }))}
                                            loadOptions={(input) => api({ method: 'get', action: '/participante', token: token, params: { nome: input, situacaoRegistro: 'ativo' } })
                                                .then(r => (r.data.data || []).map(p => ({ value: p.id, label: (p.codigo ? p.codigo + ' - ' : '') + (p.nomefantasia || p.nome) })))}
                                        />
                                    </FinField>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => setModal(null)} disabled={modal.salvando}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={gerar} disabled={!modal.favorecido || modal.salvando}>
                                    {modal.salvando ? 'Gerando…' : 'Gerar conta'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
